type Props = {
  label: string;
  Icon: (props: { height: number }) => JSX.Element;
  onClick: () => void;
  selected: boolean;
};

export const FilterButton = (props: Props) => {
  return (
    <div
      key={props.label}
      className={`flex-1 p-4 rounded-[8px] text-center cursor-pointer hover:bg-[#ffffff14] ${
        props.selected ? "bg-[#ffffff14]" : "bg-[#232628]"
      } flex items-center justify-center gap-1`}
      onClick={props.onClick}
    >
      <props.Icon height={16} />
      {props.label}
    </div>
  );
};
